<template>
    <v-card min-width="20vw" align="center" justify="center" light outlined>
        <v-card-title :style="(firstStrategy)? 'background-color: #fff75f' : 'background-color: #d2d7e1'">
            <v-list-item>
                <v-list-item-title v-if="!firstStrategy"><h2>{{ $t('addStrategy') }}</h2></v-list-item-title>
                <v-list-item-title v-else><h2>{{ $t('addFirstStrategy') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action v-if="!firstStrategy"><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p v-if="firstStrategy" v-html="$t('addingTheFirstStrategy')"></p>
            <div class="d-flex mb-5">
                <v-btn class="switch-button" :disabled="myOwn" @click="changeModule">{{ $t('createMyOwn') }}</v-btn>
                <v-btn class="switch-button" :disabled="!myOwn" @click="changeModule">{{ $t('searchStrategy') }}</v-btn>
            </div>
            <OwnStrategy @closeWindow="closeWindow" v-if="myOwn"/>
            <SearchStrategy @closeWindow="closeWindow" v-if="!myOwn"/>
        </v-card-text>
    </v-card>
</template>

<script>
    import SearchStrategy from "./SearchStrategy";
    import OwnStrategy from "./OwnStrategy";

    export default {
        name: "AddStrategy",
        components: {OwnStrategy, SearchStrategy},
        data() {
            return {
                myOwn: true,
                firstStrategy: false,
            };
        },
        mounted() {
            this.firstStrategy = (this.$store.state.user.strategies.length === 0);
        },
        methods: {
            changeModule(){
                this.myOwn = !this.myOwn;
            },
            closeWindow(){
                this.$emit('closeWindow');
            }
        },
    }
</script>

<style scoped>
    .switch-button {
        color: #ffffff !important;
        background-color: #111111 !important;
        border: 0;
    }

</style>


<i18n>
{
  "en": {
    "addStrategy" : "Add Strategy",
    "addFirstStrategy" : "Add First Strategy!",
    "addingTheFirstStrategy": "Let's add the first <b>investment strategy</b>,<br>you can add a technical or fundamental strategy.",
    "createMyOwn": "Create My Own",
    "searchStrategy": "Search Strategy"
  },
  "es":{
    "addStrategy" : "Agregar Estrategia",
    "addFirstStrategy" : "¡Agrega Primera Estrategia!",
    "addingTheFirstStrategy" : "Vamos a agregar tu primera <b>estrategia de inversión</b>,<br>puedes agregar una estrategia tecnica o fundamental.",
    "createMyOwn": "Crear Estrategia Propia",
    "searchStrategy": "Buscar Estrategia"
  }
}
</i18n>
